/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { Badge } from '@mantine/core'

function getColor (prospecting: Prospecting) {
  const { succeeded } = prospecting
  let color

  if (succeeded === true) {
    color = 'green'
  } else if (succeeded === false) {
    color = 'red'
  } else {
    color = 'blue'
  }
  return color
}

export type ProspectingStatusBadgeProps = {
  prospecting: Prospecting
}

function ProspectingStatusBadge (props: ProspectingStatusBadgeProps) {
  const { prospecting } = props
  const { succeeded } = prospecting
  const color = useMemo(() => getColor(prospecting), [prospecting])

  return (
    <Badge color={color}>
      {succeeded === true
        ? <FormattedMessage
          id="succeeded"
          defaultMessage="Succès"
        />
        : null}

      {succeeded === false
        ? <FormattedMessage
          id="failure"
          defaultMessage="Échec"
        />
        : null}

      {succeeded === null
        ? <FormattedMessage
          id="ongoing"
          defaultMessage="En cours"
        />
        : null}
    </Badge>
  )
}

export default ProspectingStatusBadge
